// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { useState, useEffect } from 'react';
import { Alert, Modal, Box, Button, SpaceBetween } from '@awsui/components-react';
import DISCLAIMER_CONTENT from './disclaimerContent';

const DISCLAIMER_ACKNOWLEDGED_KEY = 'disclaimerAcknowledged';

const Disclaimer = () => {
  const [visible, setVisible] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  // Check localStorage on initial mount only
  useEffect(() => {
    const disclaimerAcknowledged = localStorage.getItem(DISCLAIMER_ACKNOWLEDGED_KEY);
    if (!disclaimerAcknowledged) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    // Save to localStorage that user has acknowledged the disclaimer
    localStorage.setItem(DISCLAIMER_ACKNOWLEDGED_KEY, 'true');
    setVisible(false);
  };

  const handleCancel = () => {
    setShowAlert(true);
  };

  return (
    <Modal visible={visible} onDismiss={handleCancel} header="Disclaimer" closeAriaLabel="Close modal" size="medium">
      <Box padding="m">
        <SpaceBetween direction="vertical" size="l">
          {showAlert && <Alert type="warning">Acknowledgment of the disclaimer is required to proceed.</Alert>}
          <div style={{ maxHeight: '800px', overflowY: 'auto', paddingRight: '10px' }}>{DISCLAIMER_CONTENT}</div>
          <Button variant="primary" onClick={handleDismiss}>
            click box for approval
          </Button>
        </SpaceBetween>
      </Box>
    </Modal>
  );
};

export default Disclaimer;
